import React, { useState, useRef, useEffect } from 'react';
import Webcam from 'react-webcam';
import { useNavigate, Link } from 'react-router-dom';
import '../../styles/PhotoBooth.css';

function LLOriginalFrame() {
  // ...existing code from PhotoBooth.js...
  const webcamRef = useRef(null);
  const navigate = useNavigate();
  const [capturedImages, setCapturedImages] = useState([]);
  const [countdown, setCountdown] = useState(10);
  const [takingPhotos, setTakingPhotos] = useState(false);
  const [photoCount, setPhotoCount] = useState(0);
  const [flashVisible, setFlashVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [intervalTime, setIntervalTime] = useState(5); // Default to 5 seconds
  const [viewHeight, setViewHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setViewHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    let interval;
    if (takingPhotos && countdown > 0) {
      interval = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
    }
    if (countdown === 0 && photoCount < 8) {
      triggerFlash();
      capture();
      setCountdown(intervalTime);  // Reset countdown based on the selected interval
      setPhotoCount(prev => prev + 1);
    }
    if (photoCount === 8) {
      clearInterval(interval);
      setTakingPhotos(false);
      setTimeout(() => {
        navigate('/select', { state: { images: capturedImages } });
      }, 500);
    }
    return () => clearInterval(interval);
  }, [countdown, takingPhotos, photoCount, capturedImages, navigate, intervalTime]);

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImages(prev => [...prev, imageSrc]);
  };

  const triggerFlash = () => {
    setFlashVisible(true);
    setTimeout(() => setFlashVisible(false), 150);
  };

  const startPhotoSession = () => {
    setCapturedImages([]);
    setPhotoCount(0);
    setTakingPhotos(true);
    setCountdown(intervalTime); // Start countdown based on the selected interval
  };

  const handleIntervalChange = (e) => {
    setIntervalTime(Number(e.target.value)); // Update the interval based on user selection
  };

  // Calculate appropriate webcam dimensions based on device
  const getWebcamDimensions = () => {
    if (isMobile) {
      // 3:4 aspect ratio for mobile, vertical
      return {
        width: 360,
        height: 480
      };
    } else {
      // 3:4 aspect ratio for desktop, vertical
      return {
        width: 450,
        height: 600
      };
    }
  };

  const webcamDimensions = getWebcamDimensions();

  // Set video constraints to match the container's aspect ratio and size (vertical)
  const videoConstraints = {
    facingMode: 'user',
    width: webcamDimensions.width,
    height: webcamDimensions.height,
    aspectRatio: 3/4
  };

  return (
    <div className="PhotoBooth">
      {/* Back link to welcome page */}
      <Link to="/" style={{ 
        position: 'absolute', 
        top: '20px', 
        left: '20px', 
        color: '#FF2F2F', 
        textDecoration: 'none',
        fontSize: '20px',
        zIndex: 10
      }}>
        ← Back
      </Link>

      {/* Mobile-only Start Button at the Top */}
      {isMobile && !takingPhotos && (
        <div className="mobile-start-button-wrapper">
          <button onClick={startPhotoSession} className="start-button">
            Start!
          </button>
        </div>
      )}
      {isMobile && takingPhotos &&  (
          <div className="photo-counter">{photoCount}/8 Photos</div>
      )}

      <div className="photo-layout">
        <div 
          className="webcam-container"
          style={{
            width: `${webcamDimensions.width}px`,
            height: `${webcamDimensions.height}px`,
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#000',
            borderRadius: '18px',
          }}
        >
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={videoConstraints}
            mirrored={true}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '18px',
            }}
          />
          {flashVisible && <div className="flash-overlay" />}
          {takingPhotos && (
            <div className="countdown-overlay">{countdown}</div>
          )}
        </div>
        <div className="info-container">
          {!takingPhotos && !isMobile && (
            <div className="controls-stack">
              <div className="interval-selector">
                <label htmlFor="interval">Select Interval:</label>
                <select id="interval" value={intervalTime} onChange={handleIntervalChange}>
                  <option value={5}>5 Seconds</option>
                  <option value={10}>10 Seconds</option>
                </select>
              </div>
              {!isMobile && !takingPhotos && (
                <button onClick={startPhotoSession} className="start-button">
                  Start!
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );  
}

export default LLOriginalFrame;
